// extracted by mini-css-extract-plugin
export default {"productCarousel":"G0-z"};